var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import DocumentDialog from "../components/documentdialog.vue";
import ErrorDialog from "../components/errordialog.vue";
import Spinner from "../components/spinner.vue";
import { emptyGraph, } from "./utilities/aux";
function emptyResources() {
    return {
        attachments: {},
        gltfs: {},
        pngs: {},
        svgs: {},
        technicalDrawings: {},
        sheetTappingNodeData: [],
        tubeCuttingData: [],
        canForceSheetPartData: [],
        problematicGeometryGlfts: {},
    };
}
function emptySaveGraph() {
    return {
        graph: emptyGraph(),
        resources: emptyResources(),
    };
}
let App = class App extends Vue {
    constructor() {
        super(...arguments);
        this.savedGraph = emptySaveGraph();
    }
    graphNodeIds() { return this.knownGraphNodeIds; }
    closeErrorDialog() { }
    closeWizard() { }
    saveGraph() {
        this.savedGraph = {
            graph: this.graph,
            resources: this.resources,
        };
        this.graphNodeIds();
    }
    createResources() {
        if (this.graph === undefined || this.graph.articles === undefined) {
            return emptyResources();
        }
        const r = this.graph.articles.reduce((res, article) => {
            for (const node of article.nodes) {
                res.svgs[node.nodeIdKey] = this.graph.resources.svgs[node.vertex];
                if (!(node.nodeIdKey in res.pngs)) {
                    res.pngs[node.nodeIdKey] = this.graph.resources.pngs[node.vertex];
                }
                if (!(node.nodeIdKey in res.gltfs)) {
                    res.gltfs[node.nodeIdKey] = this.graph.resources.gltfs[node.vertex];
                }
                if (!(node.nodeIdKey in res.attachments)) {
                    res.attachments[node.nodeIdKey] = this.graph.resources.attachments[node.vertex];
                }
                if (!(node.nodeIdKey in res.gltfs)) {
                    res.gltfs[node.nodeIdKey] = this.graph.resources.gltfs[node.vertex];
                }
                if (!(node.nodeIdKey in res.technicalDrawings)) {
                    res.technicalDrawings[node.nodeIdKey] = this.graph.resources.technicalDrawings[node.vertex];
                }
                const tubeData = this.graph.resources.tubeCuttingData.find(t => t.vertexKey === node.vertex);
                if (tubeData !== undefined) {
                    res.tubeCuttingData.push({
                        nodeIdKey: node.nodeIdKey,
                        processId: tubeData.processId,
                        dimX: tubeData.dimX,
                        tubeProfileGeometry: tubeData.tubeProfileGeometry,
                        tubeSpecificationId: tubeData.tubeSpecificationId,
                        tubeMaterialId: tubeData.tubeMaterialId,
                    });
                }
                const sheetTappingNodeData = this.graph.resources.sheetTappingNodeData.find(t => t.laserSheetCuttingVertexKey === node.vertex);
                if (sheetTappingNodeData !== undefined) {
                    const index = res.sheetTappingNodeData.findIndex(v => v.nodeIdKey === node.nodeIdKey);
                    if (index === -1) {
                        res.sheetTappingNodeData.push({
                            nodeIdKey: node.nodeIdKey,
                            laserSheetCuttingVertexKey: sheetTappingNodeData.laserSheetCuttingVertexKey,
                            svg: sheetTappingNodeData.svg,
                            candidates: sheetTappingNodeData.candidates,
                            selection: sheetTappingNodeData.selection,
                        });
                    }
                    else {
                        res.sheetTappingNodeData[index] = {
                            nodeIdKey: node.nodeIdKey,
                            laserSheetCuttingVertexKey: sheetTappingNodeData.laserSheetCuttingVertexKey,
                            svg: sheetTappingNodeData.svg,
                            candidates: sheetTappingNodeData.candidates,
                            selection: sheetTappingNodeData.selection,
                        };
                    }
                }
                if (!(node.nodeIdKey in res.problematicGeometryGlfts)) {
                    res.problematicGeometryGlfts[node.nodeIdKey] = this.graph.resources.problematicGeometryGlfts[node.vertex];
                }
                const canForceData = this.graph.resources.canForceSheetPartData.find(t => t.vertexKey === node.vertex);
                if (canForceData !== undefined) {
                    res.canForceSheetPartData.push({
                        nodeIdKey: node.nodeIdKey,
                        canForce: canForceData.canForce,
                    });
                }
            }
            return res;
        }, this.savedGraph.resources);
        return r;
    }
    get resources() { return this.createResources(); }
    get knownGraphNodeIds() {
        return [
            ...Object.keys(this.resources.pngs),
            ...Object.keys(this.resources.svgs),
            ...Object.keys(this.resources.gltfs),
            ...Object.keys(this.resources.technicalDrawings),
            ...this.resources.tubeCuttingData.map(t => t.nodeIdKey),
            ...this.resources.sheetTappingNodeData.map(s => s.nodeIdKey),
            ...Object.keys(this.resources.problematicGeometryGlfts),
            ...this.resources.canForceSheetPartData.map(t => t.nodeIdKey),
        ].filter((k, index, self) => self.indexOf(k) === index);
    }
    created() {
        this.savedGraph = {
            graph: this.graph,
            resources: emptyResources(),
        };
        this.networkBroker.addSlot("save-graph", () => this.saveGraph());
    }
};
__decorate([
    Prop({ required: true })
], App.prototype, "busy", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "graph", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "possibleWizardVertexKeys", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "readOnlyModeEnabled", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "Renderer3d", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "scriptResult", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], App.prototype, "showPartCreationButton", void 0);
__decorate([
    Inject()
], App.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], App.prototype, "graphNodeIds", null);
__decorate([
    Emit()
], App.prototype, "closeErrorDialog", null);
__decorate([
    Emit()
], App.prototype, "closeWizard", null);
App = __decorate([
    Component({
        components: {
            DocumentDialog,
            ErrorDialog,
            Spinner,
        },
        name: "App",
    })
], App);
export default App;
